define(function (require) {

    var Backbone = require('backbone');
    // var ModelMenu = require('components/menu/model');
    // var MenuStructure = require('app/components/menu/structure');
    // var AppConfig = require("config/application");
    // var app = require('app/app');
    var AppConfig = require('config/application');

    var StatisticSourcesPositionsCollection = Backbone.Collection.extend({
        defaultGlobalName: 'StatisticSourcesPositions', // app.Collection.StatisticSourcesPositions
        url: AppConfig.host + "/rest/system/columns/get/statistic",
        initialize: function (models, options) {
            this.setAvailableGlobal(options);
        },
        parse: function (response, options) {
            if (response.status != 1 ||
                !response.data ||
                !response.data.additional_data ||
                !response.data.additional_data.mrp ||
                !response.data.additional_data.mrp.length) {
                return [];
            }

            var newData = [];
            response.data.additional_data.mrp.map(function (item, index) {
                newData.push({
                    id: item,
                    position: index
                });
            }.bind(this));

            return newData;
        },
        setAvailableGlobal: function (options) {
            if (options && options.globalName) {
                StatisticSourcesPositionsCollection.globalName = options.globalName
            }

            if (!StatisticSourcesPositionsCollection.globalName) {
                StatisticSourcesPositionsCollection.globalName = this.defaultGlobalName;
            }

            app.Collections[StatisticSourcesPositionsCollection.globalName] = this;
        },
    });

    return StatisticSourcesPositionsCollection;
});
